var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57782 15.8638C2.70641 15.8638 2 15.2103 2 14.4042C2 14.0018 2.17963 13.6172 2.49643 13.3414L13.9186 3.39671C14.5262 2.86776 15.4739 2.86776 16.0814 3.39671L27.5036 13.3414C28.1381 13.8938 28.1684 14.8176 27.5712 15.4046C27.2729 15.6977 26.8572 15.8638 26.4222 15.8638H26.0447V26.0809C26.0447 27.693 24.6319 29 22.8892 29H19.7303C18.425 29 17.3668 27.9729 17.3668 26.7059V21.7021C17.3668 20.928 16.7131 20.2895 15.9052 20.246L15.7889 20.2425H14.2111C13.3744 20.2425 12.6841 20.8471 12.637 21.5945L12.6333 21.7021V26.7059C12.6333 27.9729 11.5751 29 10.2697 29H7.1109C5.36808 29 3.95526 27.693 3.95526 26.0809V15.8638H3.57782Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.d75087231c7520ca1baf5b748df5aa3f.svg";
export { ForwardRef as ReactComponent };